(function (proto) {
    if (typeof proto.average === "function")
        return;
    proto.average = function average(callbackFn) {
        return this.sum(callbackFn) / (this.length || 1);
    };
})(Array.prototype);
(function (proto) {
    if (typeof proto.distinct === "function")
        return;
    proto.distinct = function distinct(callbackFn) {
        if (!callbackFn) {
            callbackFn = function (x) { return x; };
        }
        var existing = [];
        var filtered = this.filter(function (value, index, array) {
            var key = callbackFn(value, index, array);
            var isUnique = existing.indexOf(key) < 0;
            if (isUnique) {
                existing.push(key);
            }
            return isUnique;
        });
        return filtered;
    };
})(Array.prototype);
(function (proto) {
    if (typeof proto.find === "function")
        return;
    proto.find = function find(callbackFn) {
        var result = undefined;
        this.some(function (value, index, array) {
            var isFound = callbackFn(value, index, array);
            if (isFound) {
                result = value;
            }
            return isFound;
        });
        return result;
    };
})(Array.prototype);
(function (proto) {
    if (typeof proto.flatMap === "function")
        return;
    proto.flatMap = function flatMap(callbackFn) {
        var arrays = this.map(callbackFn);
        var result = (_a = Array.prototype).concat.apply(_a, arrays);
        return result;
        var _a;
    };
})(Array.prototype);
(function (proto) {
    if (typeof proto.groupBy === "function")
        return;
    proto.groupBy = function groupBy(callbackFn) {
        var map = new Map();
        this.forEach(function (item, currentIndex, array) {
            var key = callbackFn(item, currentIndex, array);
            var targetArray = map.get(key) || [];
            targetArray.push(item);
            map.set(key, targetArray);
        });
        return map;
    };
})(Array.prototype);
(function (proto) {
    if (typeof proto.max === "function")
        return;
    proto.max = function max(callbackFn) {
        if (!callbackFn) {
            callbackFn = function (t) { return t; };
        }
        var maxValue = Number.NEGATIVE_INFINITY;
        var result;
        this.forEach(function (value, index, array) {
            var v = callbackFn(value, index, array);
            if (v >= maxValue) {
                maxValue = v;
                result = value;
            }
        });
        return result;
    };
})(Array.prototype);
(function (proto) {
    if (typeof proto.min === "function")
        return;
    proto.min = function min(callbackFn) {
        if (!callbackFn) {
            callbackFn = function (t) { return t; };
        }
        var minValue = Number.POSITIVE_INFINITY;
        var result;
        this.forEach(function (value, index, array) {
            var v = callbackFn(value, index, array);
            if (v <= minValue) {
                minValue = v;
                result = value;
            }
        });
        return result;
    };
})(Array.prototype);
(function (proto) {
    if (typeof proto.scan === "function")
        return;
    proto.scan = function scan(callbackFn, initialValue) {
        var result = new Array(this.length);
        var acc = initialValue;
        this.forEach(function (value, index, array) {
            result[index] = acc = callbackFn(acc, value, index, array);
        });
        return result;
    };
})(Array.prototype);
(function (proto) {
    if (typeof proto.sortBy === "function")
        return;
    proto.sortBy = function sum(callbackFn) {
        return this.slice().sort(function (a, b) { return callbackFn(a) - callbackFn(b); });
    };
})(Array.prototype);
(function (proto) {
    if (typeof proto.sum === "function")
        return;
    proto.sum = function sum(callbackFn) {
        var callback = (typeof callbackFn === 'function') ? callbackFn : function (x) { return Number(x); };
        return this.reduce(function (sum, value, currentIndex, array) { return sum + callback(value, currentIndex, array); }, 0);
    };
})(Array.prototype);
(function (arrayConstructor) {
    if (typeof arrayConstructor.zip === "function")
        return;
    arrayConstructor.zip = function zip(leftArray, rightArray, merge) {
        var outputLength = Math.min(leftArray.length, rightArray.length);
        var result = new Array(outputLength);
        for (var i = 0; i < outputLength; i++) {
            result[i] = merge(leftArray[i], rightArray[i]);
        }
        return result;
    };
})(Array);
//# sourceMappingURL=index.js.map